export default "__VITE_ASSET__B4Eyj38A__"